/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderDocuments = 'PreApprovalDocs' | 'AdhocSummaryDocs' | 'InvitationLog' | 'CancelDocs' | 'OfferOpeningDocs' | 'DecisionDocs' | 'ClosingDocs' | 'RevisedOfferOpeningDocs' | 'OffersSummaryExcel' | 'RecallDocs' | 'Debriefing' | 'DecisionExcel' | 'CollectiveClosingDocs';

export const TenderDocuments = {
    PreApprovalDocs: 'PreApprovalDocs' as TenderDocuments,
    AdhocSummaryDocs: 'AdhocSummaryDocs' as TenderDocuments,
    InvitationLog: 'InvitationLog' as TenderDocuments,
    CancelDocs: 'CancelDocs' as TenderDocuments,
    OfferOpeningDocs: 'OfferOpeningDocs' as TenderDocuments,
    DecisionDocs: 'DecisionDocs' as TenderDocuments,
    ClosingDocs: 'ClosingDocs' as TenderDocuments,
    RevisedOfferOpeningDocs: 'RevisedOfferOpeningDocs' as TenderDocuments,
    OffersSummaryExcel: 'OffersSummaryExcel' as TenderDocuments,
    RecallDocs: 'RecallDocs' as TenderDocuments,
    Debriefing: 'Debriefing' as TenderDocuments,
    DecisionExcel: 'DecisionExcel' as TenderDocuments,
    CollectiveClosingDocs: 'CollectiveClosingDocs' as TenderDocuments
};

